<div class="qty">
  <span
    class="qty-control qty-control-dec"
    [class.qty-disabled]="qtyControl.value === 1"
    (click)="decrementQty()"
  >
    <i class="mbi mbi-minus qty-control-icon"></i>
  </span>

  <input
    class="qty-input"
    [formControl]="qtyControl"
    type="number"
    min="1"
  >

  <span
    class="qty-control qty-control-inc"
    (click)="incrementQty()"
  >
    <i class="mbi mbi-plus qty-control-icon"></i>
  </span>
</div>
